import AnnotationProcessor from './processor';
/**
 * @description
 * The AnnotationUtilsclass contains utility APIs that handle the annotation for a property
 */
class AnnotationUtils {
  /**
   * This API obtains the name of an annotated property
   * @param value an Annotated property
   * @returns returns the name of the annotated property as a string
   * @public
   * @example <caption>In this example, the API returns the literal property name</caption>
   * PCore.getAnnotationUtils().getPropertyName(value)
   * PCore.getAnnotationUtils().getPropertyName('@P .pyName') return ".pyName"
   */

  static getPropertyName(value: string) {
    return AnnotationProcessor.getPropertyName(value);
  }

  /**
   * This API determines if a specified value is a property
   * @param value An annotated property
   * @returns true if the specified value is a property else return false
   * @public
   * @example <caption>In this example, the API checks whether the passed value is Property</caption>
   * PCore.getAnnotationUtils().isProperty(value)
   * PCore.getAnnotationUtils().isProperty('@P .pyName') return true
   */

  static isProperty(value: string) {
    return AnnotationProcessor.isProperty(value);
  }

  /**
   * This API returns the leaf property name of an embedded property
   * @param value an Annotated property
   * @returns Return the leaf property of the annotated property
   * @private
   * @example <caption>In this example, the API returns the leaf property</caption>
   * PCore.getAnnotationUtils().getLeafPropertyName(value);
   * const leftProperty = PCore.getAnnotationUtils().getLeafPropertyName('@P .Expenses.Home');
   */

  static getLeafPropertyName(value: string) {
    return AnnotationProcessor.getLeafPropertyName(value);
  }

  /**
   * This API returns whether the property is internal property or not
   * @param propertyName an Annotated property
   * @returns Return the boolean value
   * @private
   * @example <caption>In this example, the API returns the boolean value whether the property is internal or not</caption>
   * PCore.getAnnotationUtils().isPropertyInternal(value);
   * const isInternal = PCore.getAnnotationUtils().isPropertyInternal('Home');
   */
  static isPropertyInternal(propertyName: string) {
    return propertyName.startsWith('px') || propertyName.startsWith('pz');
  }
}

export default AnnotationUtils;
